import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useAlertContext } from '@/contexts/AlertContext'
import { disableSite, enableSite } from '@/features/site/endpoints/sites'

export type UseUpdateSiteStatusMutationResult = ReturnType<typeof useUpdateSiteStatusMutation>

export function useUpdateSiteStatusMutation() {
  const { pushAlert } = useAlertContext()
  const { t } = useTranslation()

  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { isActive: boolean; uuid: string; location: string; name: string }) => {
      return variables.isActive
        ? enableSite(variables.uuid, variables.location)
        : disableSite(variables.uuid, variables.location)
    },
    onSuccess: async (_, variables) => {
      const { isActive, name } = variables

      pushAlert({
        message: t(`customers.customer_disable.customer_is_now_${isActive ? 'enabled' : 'disabled'}_success_message`, {
          customerName: name,
        }),
        severity: 'success',
      })
    },
  })

  return {
    updateSiteStatus: mutateAsync,
    ...mutationResult,
  }
}
